import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, PhoneCall, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { navigationItems } from "@/data/navigation";

const LOGO_URL = "/monarch-logo-transparent.png";

export function Header({ siteData }) {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 px-4 py-4 md:px-6" data-testid="site-header">
      <div className="flex w-full max-w-7xl items-center justify-between border border-white/70 backdrop-blur-xl mx-auto px-4 py-3 md:px-6 md:py-4 rounded-[2rem] shadow-[0_24px_70px_rgba(16,24,40,0.14)] !bg-[#318D09]">
        <Link className="flex shrink-0 items-center" data-testid="header-logo-link" to="/">
          <div className="h-16 w-40 overflow-hidden rounded-2xl bg-white/95 p-1 shadow-sm sm:h-20 sm:w-48 lg:h-24 lg:w-56" data-testid="header-logo-frame">
            <img
              alt="Monarch Solar & Roofing Solutions logo"
              className="h-full w-full object-contain"
              data-testid="header-logo-image"
              src={LOGO_URL} />

          </div>
        </Link>

        <nav className="hidden items-center gap-1 xl:flex" data-testid="header-desktop-nav">
          {navigationItems.map((item) =>
          <NavLink
            key={item.path}
            className={({ isActive }) =>
            `rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
            isActive ? "bg-primary text-primary-foreground" : "text-foreground hover:bg-primary/10"}`

            }
            data-testid={`header-nav-${item.label.toLowerCase()}-link`}
            to={item.path}>

              {item.label}
            </NavLink>
          )}
        </nav>

        <div className="hidden items-center gap-3 xl:flex">
          <a
            className="text-sm font-semibold text-foreground transition-colors hover:text-primary"
            data-testid="header-phone-link"
            href={`tel:${siteData.phone}`}>

            {siteData.phone}
          </a>
          <Button asChild className="rounded-full px-5 py-5 text-sm">
            <Link data-testid="header-contact-button" to="/contact">
              Get Free Quote
            </Link>
          </Button>
        </div>

        <button
          aria-label="Toggle menu"
          className="inline-flex h-11 w-11 items-center justify-center border border-primary/20 xl:hidden rounded-full text-primary !bg-[rgba(255,255,255,0.74)]"
          data-testid="header-mobile-menu-button"
          onClick={() => setIsOpen((value) => !value)}
          type="button">

          {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {isOpen &&
      <div className="mx-auto mt-3 w-full max-w-7xl rounded-[2rem] border border-white/60 bg-white/95 p-4 shadow-[0_20px_60px_rgba(16,24,40,0.08)] backdrop-blur-xl xl:hidden" data-testid="header-mobile-menu">
          <nav className="flex flex-col gap-2" data-testid="header-mobile-nav">
            {navigationItems.map((item) =>
          <NavLink
            key={item.path}
            className={({ isActive }) =>
            `rounded-2xl px-4 py-3 text-sm font-semibold transition-colors ${
            isActive ? "bg-primary text-primary-foreground" : "bg-primary/5 text-foreground"}`

            }
            data-testid={`header-mobile-${item.label.toLowerCase()}-link`}
            onClick={closeMenu}
            to={item.path}>

                {item.label}
              </NavLink>
          )}
          </nav>
          <div className="mt-4 flex flex-col gap-3 rounded-2xl bg-slate-950 px-4 py-4 text-white" data-testid="header-mobile-contact-card">
            <p className="text-sm uppercase tracking-[0.25em] text-white/60" data-testid="header-mobile-contact-label">
              Call now
            </p>
            <a className="text-lg font-semibold" data-testid="header-mobile-phone-link" href={`tel:${siteData.phone}`}>
              <span className="inline-flex items-center gap-2">
                <PhoneCall className="h-4 w-4" />
                {siteData.phone}
              </span>
            </a>
          </div>
        </div>
      }
    </header>);

}